import Vue from "vue";

function replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, "g"), replace);
}
export default {
    methods: {
        showNotification(msg, type) {
            Vue.toasted.show(replaceAll(msg + "", "Error:", ""), {
                keepOnHover: true,
                closeOnSwipe: false,
                theme: "bubble",
                duration: 3000,
                type: type || "info",
                position: "top-right",
            });
        },
    }
}